<nha-popup
	hasScrollbar="true"
	#nhaPopup
	[isClick]="true"
	(openChanged)="openChanged($event)"
	nhaTest="app-launcher-popup"
	contentClass="launcher-popup-content"
>
	<button mat-icon-button nhaTest="app-launcher" class="app-launcher-target" popup-target>
		<mat-icon>apps</mat-icon>
	</button>

	<div class="app-launcher-menu" nhaTest="app-launcher-menu" popup-content>
		<mat-tab-group #tabGroup [selectedIndex]="initialTab" [disableRipple]="true" mat-stretch-tabs>
			<mat-tab label="My Favorites">
				<ng-template matTabContent>
					<nha-loader [loading]="isLoading$ | async"></nha-loader>
					@if (favorites$ | async; as favorites) {
						<div class="icon-list">
							@for (link of favorites; track link.portalLinkID) {
								<nha-portal-link
									[portalLinkName]="link.portalLinkName"
									[portalLinkID]="link.portalLinkID"
									[linkUrl]="link.linkUrl"
									[iconColor]="link.iconColor"
									[iconSVG]="link.iconSVG"
									[iconClass]="link.iconClass"
									[iconLetters]="link.iconLetters"
									[isFavorite]="link.isFavorite"
								>
								</nha-portal-link>
							} @empty {
								<div class="no-faves">Select favorites from the <a role="button" (click)="tabGroup.selectedIndex = 1">myNHA Apps</a> tab.</div>
							}
						</div>
					}
				</ng-template>
			</mat-tab>
			<mat-tab label="myNHA Apps" [disabled]="isLoading$ | async">
				<div class="searchbox">
					<nha-search-box [value]="searchText" (changed)="searchText = $event" [lockOpen]="true" [gray]="true" [boxShadow]="false"></nha-search-box>
				</div>
				<div class="icon-list" nhaTest="link-search-list">
					@for (link of filteredLinkList$(searchText) | async; track link.portalLinkID) {
						<nha-portal-link
							[portalLinkName]="link.portalLinkName"
							[portalLinkID]="link.portalLinkID"
							[linkUrl]="link.linkUrl"
							[iconColor]="link.iconColor"
							[iconSVG]="link.iconSVG"
							[iconClass]="link.iconClass"
							[iconLetters]="link.iconLetters"
							[isFavorite]="link.isFavorite"
						>
						</nha-portal-link>
					}
				</div>
			</mat-tab>
		</mat-tab-group>
		<div class="app-list-footer">
			<button color="primary" mat-button (click)="nhaPopup.isOpen = false">CLOSE LAUNCHER</button>
		</div>
	</div>
</nha-popup>
